// import React, { useState } from 'react';
// import axios from 'axios';

// const FileUpload = () => {
//   const [file, setFile] = useState(null);
//   const [status, setStatus] = useState('');
//   const [responseHtml, setResponseHtml] = useState(''); // Store HTML response as a string
//   const [error, setError] = useState('');

//   // Handle file selection
//   const handleFileChange = (e) => {
//     setFile(e.target.files[0]);
//   };

//   // Handle file upload and submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!file) {
//       setError('Please select a file to upload.');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       setStatus('Uploading...');
      
//       const response = await axios.post('http://192.168.1.75:3000/process-document', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });

//       setResponseHtml(response.data); // Assume response.data contains the HTML string
//       setStatus('File uploaded successfully!');
//     } catch (err) {
//       setError('An error occurred during the file upload.');
//       console.error('Error uploading file:', err);
//     }
//   };

//   return (
//     <div>
//       <h2>File Upload</h2>
//       <form onSubmit={handleSubmit}>
//         <input
//           type="file"
//           accept=".pdf"
//           onChange={handleFileChange}
//         />
//         <button type="submit">Upload and Submit</button>
//       </form>

//       {status && <p>{status}</p>}
//       {error && <p style={{ color: 'red' }}>{error}</p>}

//       {/* Render the HTML response */}
//       {responseHtml && (
//         <div
//           dangerouslySetInnerHTML={{ __html: responseHtml }}
//         />
//       )}
//     </div>
//   );
// };

// export default FileUpload;

import React, { useState } from "react";
import axios from "axios";

const FileUpload = () => {
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState("");
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState("");

  // Handle file selection
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Handle file upload and submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setError("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setStatus("Uploading...");
      const response = await axios.post(
        "https://poc.adarshtated.com/upload/vision",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setResponseData(response.data); // Access the `data` field
      setStatus("File uploaded successfully!");
      setError("");
    } catch (err) {
      setError("An error occurred during the file upload.");
      setStatus("");
      console.error("Error uploading file:", err);
    }
  };

  // Helper function to render nested objects in table rows
  const renderTableRows = (data, parentKey = "") => {
    return Object.entries(data).map(([key, value], index) => {
      const rowKey = parentKey ? `${parentKey}.${key}` : key;

      // Style parent keys (e.g., data, items, dispatch, receipt) with larger font size
      const isParentKey = ["data", "items", "dispatch", "receipt"].includes(key);

      // If the value is an object, recursively render rows
      if (typeof value === "object" && value !== null) {
        return (
          <React.Fragment key={index}>
            <tr>
              <td colSpan="2" style={isParentKey ? styles.parentKey : styles.defaultKey}>
                <strong>{key}</strong>
              </td>
            </tr>
            {renderTableRows(value, rowKey)}
          </React.Fragment>
        );
      }

      // Render rows for primitive values
      return (
        <tr key={rowKey}>
          <td style={styles.td}>{key}</td>
          <td style={styles.td}>{value ? value.toString() : "N/A"}</td>
        </tr>
      );
    });
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>File Upload</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="file"
          accept=".pdf"
          onChange={handleFileChange}
          style={styles.input}
        />
        <button type="submit" style={styles.button}>
          Upload and Submit
        </button>
      </form>

      {status && <p style={styles.status}>{status}</p>}
      {error && <p style={styles.error}>{error}</p>}

      {/* Displaying the response data */}
      {responseData && (
        <div style={styles.tableContainer}>
          <h3>Response Data</h3>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Key</th>
                <th style={styles.th}>Value</th>
              </tr>
            </thead>
            <tbody>{renderTableRows(responseData)}</tbody>
          </table>
          <div style={styles.downloadContainer}>
            <a
              href={responseData.csvDownloadUrl}
              download
              style={styles.downloadButton}
            >
              Download CSV
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

// Styles
const styles = {
  container: {
    fontFamily: "'Arial', sans-serif",
    maxWidth: "800px",
    margin: "0 auto",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  header: {
    textAlign: "center",
    color: "#333",
    fontSize: "24px",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  input: {
    padding: "10px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    width: "100%",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    width: "100%",
    maxWidth: "200px",
    textAlign: "center",
  },
  status: {
    textAlign: "center",
    fontSize: "16px",
    color: "#28a745",
  },
  error: {
    textAlign: "center",
    fontSize: "16px",
    color: "#dc3545",
  },
  tableContainer: {
    marginTop: "20px",
    overflowX: "auto",
    backgroundColor: "#f9f9f9",
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "10px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
  },
  th: {
    textAlign: "left",
    backgroundColor: "#007bff",
    color: "#fff",
    padding: "10px",
    border: "1px solid #ddd",
  },
  td: {
    fontSize: "14px",
    padding: "10px",
    border: "1px solid #ddd",
    verticalAlign: "top",
    textAlign: "left",
  },
  parentKey: {
    fontSize: "18px", // Larger font size for parent keys
    fontWeight: "bold",
    padding: "10px",
    backgroundColor: "#f0f8ff", // Subtle background to distinguish
    borderBottom: "1px solid #ddd",
  },
  defaultKey: {
    fontSize: "14px", // Default font size for other keys
    padding: "10px",
  },
  downloadContainer: {
    textAlign: "center",
    marginTop: "20px",
  },
  downloadButton: {
    padding: "10px 20px",
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default FileUpload;








